export const inviteeValidationConstraints = {
    address: { presence: { allowEmpty: false } },
};
